import { render, staticRenderFns } from "./Incorporation.vue?vue&type=template&id=f2cb20dc&scoped=true&"
import script from "./Incorporation.vue?vue&type=script&lang=js&"
export * from "./Incorporation.vue?vue&type=script&lang=js&"
import style0 from "./Incorporation.vue?vue&type=style&index=0&id=f2cb20dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cb20dc",
  null
  
)

export default component.exports